import { NavbarLinkMd, NavbarLinks } from '@/constants/navbar';
import { ChevronDown, TextAlignEnd } from 'lucide-react';
import { useEffect, useState } from 'react';
import { NavbarMobileViewSidebar } from './navbar/NavbarMobileView';
import { useNavigate } from 'react-router-dom';

export const Navbar = () => {
  let navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20); // change 20px as needed
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className={`fixed top-0 z-[5555] flex w-full flex-row flex-wrap items-center justify-center ${isScrolled ? 'bg-[#00142b]' : 'bg-transparent'} px-[2rem] font-inter text-[#121212]`}
    >
      <div className="hidden w-full max-w-[114rem] flex-row items-center justify-between lg:flex lg:h-[9rem]">
        <div className="flex flex-wrap items-center justify-start gap-[0rem] opacity-[0.9]">
          <div className="flex flex-wrap items-center justify-start gap-[0rem]">
            <img alt="ico" className="h-auto w-[8rem]" src="/favicon.png" />
            <h1
              style={{ fontFamily: 'PT Serif, serif' }}
              className="mt-[0rem] w-full text-[0.98rem] font-[500] tracking-[-0.3px] text-white"
            >
              NEXT-G SERVICES
            </h1>
          </div>
        </div>
        <div className="hidden items-center justify-start gap-[4rem] md:flex">
          <div className="mt-[4rem] flex flex-row flex-wrap items-stretch justify-start gap-[5rem] text-[1.6rem]">
            {NavbarLinkMd.map((item, index) => (
              <div key={index} className="hover group">
                {' '}
                <div className="flex flex-row items-center gap-[0.5rem]">
                  <p
                    onClick={() => {
                      navigate(item.link);
                    }}
                    key={item}
                    className="cursor-pointer text-[1.4rem] font-[500] text-white transition-colors duration-300 hover:text-[#0EC9AC]"
                  >
                    {item.label}
                  </p>
                  {item.sublinks && (
                    <ChevronDown
                      strokeWidth={3.5}
                      size={14}
                      className="text-white transition-all duration-200 group-hover:rotate-[180deg]"
                    />
                  )}
                </div>
                {item.sublinks && (
                  <>
                    <div className="pt-[4rem]">
                      <div
                        style={{ boxShadow: ' 0px 0px 0px 0px rgba(0, 0, 0, 0.5);' }}
                        className="sublink flex-cols absolute z-[0] ml-[-3rem] hidden max-h-[70vh] w-[22rem] gap-[1rem] gap-y-[1rem] overflow-y-auto rounded-[1rem] border-[#eee] bg-white px-[1rem] py-[1rem] group-hover:block"
                      >
                        {item.sublinks &&
                          item?.sublinks?.map((item2, index2) => (
                            <p
                              onClick={() => {
                                if (item2.link) navigate(item2.link);
                              }}
                              key={index2}
                              className={`cursor-pointe flex h-[4.83rem] w-[20rem] cursor-pointer items-center px-[1rem] text-[1.4rem] font-[500] text-[#00142C] transition-colors duration-300 hover:text-[#0EC9AC]`}
                            >
                              {item2.label}
                            </p>
                          ))}
                      </div>
                    </div>{' '}
                  </>
                )}
              </div>
            ))}
          </div>
          <div className="jusitfy-start z-[5555] flex flex-row flex-wrap gap-[4rem]">
            <div
              onClick={() => {
                navigate('/contact-us');
              }}
              className="flex h-[5.4rem] w-[17.10rem] cursor-pointer flex-row flex-wrap items-center justify-center gap-[1rem] rounded-[0.6rem] bg-[#0EC9AC] text-[1.6rem] font-[400] text-[#F9FEFF;]"
            >
              <p>CONTACT US</p>
            </div>
          </div>
        </div>
      </div>
      <div className="flex h-[8rem] w-full max-w-[114rem] flex-row flex-wrap items-center justify-between lg:hidden lg:h-[11.11rem]">
        <div className="flex flex-wrap items-center justify-start gap-[0.5rem]">
          <img alt="ico" className="h-auto w-[7.5rem]" src="/favicon.png" />
          <h1 className="mt-[-0.5rem] w-full text-[0.88rem] font-[600] tracking-[-0.3px] text-white">
            NEXT-G SERVICES
          </h1>
        </div>
        <div
          onClick={() => setIsOpen(true)}
          className="jusitfy-start flex flex-row flex-wrap gap-[4rem]"
        >
          <TextAlignEnd className="h-auto w-[3.5rem] text-[#0EC9AC]" />
        </div>
      </div>
      <NavbarMobileViewSidebar isOpen={isOpen} setIsOpen={setIsOpen} />
    </div>
  );
};
